module.exports = __webpack_public_path__ + "img/activity24.4e47f5b8.jpg";